import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axios';

// Async thunk to fetch call collections
export const fetchCallCollections = createAsyncThunk(
  'callCollections/fetchCallCollections',
  async ({ page = 1, limit = 10, search = '', callType = "", startDate = new Date(), endDate = "", ...extraParams }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/call-collections', {
        params: { page, limit, search, callType, startDate, endDate, ...extraParams },
      });
      // API response: { calls: [...], total: 1 }
      return {
        data: response.data.data.data || [],
        total: response.data.data.total || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const callDetailByPhone = createAsyncThunk(
    'callCollections/fetchCallCollections/byPhone',
    async (credentials, thunkAPI) => {
        try {
          const response = await axiosInstance.get(`/call-collections/${credentials.id}`, {
            ...credentials
          });
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch admin');
        }
      }
  );
  export const callHistoryByPhone = createAsyncThunk(
    'callCollections/fetchCallCollectionsHistory/byPhone',
    async (credentials, thunkAPI) => {
        try {
          const response = await axiosInstance.get(`/call-collections/history/${credentials.id}`, {
            ...credentials
          });
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch admin');
        }
      }
  );

  export const callNotesHistoryByPhone = createAsyncThunk(
    'callCollections/fetchCallNotesHistory/byPhone',
    async (credentials, thunkAPI) => {
        try {
          const response = await axiosInstance.get(`/call-collections/notes/${credentials.id}`, {
            ...credentials
          });
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch call notes history');
        }
      }
  );

const callCollectionSlice = createSlice({
  name: 'callCollections',
  initialState: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    callNotes: [],
    callNotesLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(fetchCallCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch call collections';
      })

      // by phone detail
      .addCase(callDetailByPhone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(callDetailByPhone.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(callDetailByPhone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch call detail';
      })

       // by phone detail History
      .addCase(callHistoryByPhone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(callHistoryByPhone.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(callHistoryByPhone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch call history';
      })

      // by phone notes history
      .addCase(callNotesHistoryByPhone.pending, (state) => {
        state.callNotesLoading = true;
        state.error = null;
      })
      .addCase(callNotesHistoryByPhone.fulfilled, (state, action) => {
        state.callNotesLoading = false;
        state.callNotes = action.payload.data || [];
      })
      .addCase(callNotesHistoryByPhone.rejected, (state, action) => {
        state.callNotesLoading = false;
        state.error = action.payload || 'Failed to fetch call notes history';
      })

  },
});

export default callCollectionSlice.reducer;
